<div class="device-container mt-4 mb-4">
<div class="d-flex w-100 pt-3 pb-3 pl-3 pr-2">
    <div class="d-flex flex-column align-items-center">
      <adp-image class="ml-20" imageClass="mb-3" imageKey="Global_Dashboard_WifiConnectedDevices_Image"></adp-image>
    </div>
    <div class="d-flex flex-column w-75 pl-3">
      <p class="u-heading-4 mb-1 font-weight-bold"><adp-label labelKey="Dashboard_ConnectedDevices_Heading"></adp-label></p>
        <div>
              <p class="u-body-2 mb-1"><adp-label labelKey="Dashboard_ConnectedDevices_SubText"></adp-label></p>
        </div>
    </div>
    <div class="d-flex justify-content-end w-25">
      <div class="d-flex">
        <mat-divider [vertical]="true"></mat-divider>
        <div class="redirect-button d-flex align-items-center">
          <a routerLink="" sf-aria-label="Global_ConnectedDevices_Aria_Label">
            <mat-icon [svgIcon]="'chevron-right-blue'"></mat-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
